import { Card, Col, Row } from "reactstrap";
import CommonTable from "../Common/CommonTable";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ResponsiveLightBackgroundTitle } from "../../../../Constant";
import { REPONSIVE_LIGHT_BACKGROUND, REPONSIVE_LIGHT_BACKGROUND_BODY, REPONSIVE_LIGHT_BACKGROUND_HEAD } from "../../../../Data/BootstrapTable/BasicTable";

export const ResponsiveLightBackground=()=> {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={ResponsiveLightBackgroundTitle} span={REPONSIVE_LIGHT_BACKGROUND} table/>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable tableClass="light-card" headData={REPONSIVE_LIGHT_BACKGROUND_HEAD}>
              {REPONSIVE_LIGHT_BACKGROUND_BODY.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.task}</td>
                  <td>{data.email}</td>
                  <td>{data.phone}</td>
                  <td>{data.assign}</td>
                  <td>{data.date}</td>
                  <td>{data.price}</td>
                  <td className={`font-${data.color}`}>{data.status}</td>
                  <td>{data.progress}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
